$mol_view_tree2_to_js_test_ex_simple_two_classes_foo $mol_object
	str \some
$mol_view_tree2_to_js_test_ex_simple_two_classes_bar $mol_view_tree2_to_js_test_ex_simple_two_classes_foo
	str \some2
